"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMBO_PREDICTED_ROUTES = void 0;
exports.isComboPredictedRoute = isComboPredictedRoute;
exports.hasComboPredictedRoute = hasComboPredictedRoute;
// Experiment currently disabled - no combo predicted routes
exports.COMBO_PREDICTED_ROUTES = new Set(["TEST_COMBO_PREDICTED_ROUTE_UUID"]);
function isComboPredictedRoute(routeId) {
    return routeId ? exports.COMBO_PREDICTED_ROUTES.has(routeId) : false;
}
function hasComboPredictedRoute(orders) {
    return orders.some(({ routeId }) => isComboPredictedRoute(routeId));
}
//# sourceMappingURL=isComboPredictedRoute.js.map